import { render, staticRenderFns } from "./RoleFunctionTable.vue?vue&type=template&id=4fa056b7"
import script from "./RoleFunctionTable.vue?vue&type=script&lang=js"
export * from "./RoleFunctionTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports